module.exports = __webpack_public_path__ + "static/media/termsOfUse.d5bf7bb5.md";